export default function initContactForm() {
  const nextBtn = document.querySelector(".cf7mls_next");
  if (!nextBtn) return;

  const fields = [
    { input: "customer_full_name", confirm: "confirm-full-name" },
    { input: "customer_full_name_kana", confirm: "confirm-full-name-kana" },
    { input: "customer_mail", confirm: "confirm-mail" },
    { input: "customer_phone_number", confirm: "confirm-phone" },
    { input: "customer_message", confirm: "confirm-message" },
  ];

  /* =========================================
     Step1必須項目チェック→ボタン制御
  ========================================= */
  function initNextButtonGuard() {
    // nextBtnが属するStep1のfieldsetを取得
    const step1Fieldset = nextBtn.closest(".fieldset-cf7mls");
    if (!step1Fieldset) return;

    // CF7が自動付与する必須クラスを持つ入力要素を取得
    const requiredFields = step1Fieldset.querySelectorAll(
      "input.wpcf7-validates-as-required, textarea.wpcf7-validates-as-required, select.wpcf7-validates-as-required",
    );

    function isFilled(field) {
      if (field.type === "checkbox" || field.type === "radio") {
        const group = step1Fieldset.querySelectorAll(
          `input[name="${field.name}"]`,
        );
        return Array.from(group).some((el) => el.checked);
      }
      return field.value.trim() !== "";
    }

    function checkValidity() {
      const allFilled = Array.from(requiredFields).every(isFilled);

      nextBtn.disabled = !allFilled;
      nextBtn.classList.toggle("is-disabled", !allFilled);
    }

    // 初期状態チェック
    checkValidity();

    // 入力監視
    requiredFields.forEach((field) => {
      field.addEventListener("input", checkValidity);
      field.addEventListener("change", checkValidity);
      field.addEventListener("blur", checkValidity);
    });
  }

  initNextButtonGuard();

  /* =========================================
     Step2 戻るボタンのアイコン＋アニメーション構造を注入
  ========================================= */
  function initBackButtonStyle() {
    const backBtn = document.querySelector(".cf7mls_back");
    if (!backBtn) return;

    const leftArrowSvg = `
      <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 10V0L0 5L5 10Z" fill="currentColor" />
      </svg>
    `;

    backBtn.innerHTML = `
      <span class="vmlink arr-vmlink back-arrow">
        <span class="color-normal">${leftArrowSvg}</span>
        <span class="color-white">${leftArrowSvg}</span>
      </span>
      <span class="vmlink lg-vmlink">
        <span class="color-normal">入力内容を修正する</span>
        <span class="color-white">入力内容を修正する</span>
      </span>
    `;
  }

  initBackButtonStyle();

  // エラー表示関数
  function showError(el, message) {
    // 既存のエラーメッセージを削除
    const existing = el.parentNode.querySelector(".custom-error-message");
    if (existing) existing.remove();

    // エラークラスを付与
    el.classList.add("wpcf7-not-valid");

    // エラーメッセージ要素を生成・挿入
    const tip = document.createElement("span");
    tip.className = "wpcf7-not-valid-tip custom-error-message";
    tip.setAttribute("aria-invalid", "true");
    tip.textContent = message;
    el.parentNode.appendChild(tip);

    // 対象フィールドにフォーカス
    el.focus();
  }

  // エラーリセット関数
  function clearError(el) {
    el.classList.remove("wpcf7-not-valid");
    const tip = el.parentNode.querySelector(".custom-error-message");
    if (tip) tip.remove();
  }

  nextBtn.addEventListener("click", function (e) {
    let hasError = false;

    // ① フリガナ：カタカナチェック
    const kana = document.getElementById("customer_full_name_kana");
    if (kana) {
      const kanaPattern = /^[ァ-ヶー　 ]+$/;
      if (kana.value !== "" && !kanaPattern.test(kana.value)) {
        showError(kana, "フリガナはカタカナで入力してください。");
        hasError = true;
      } else {
        clearError(kana);
      }
    }

    // ② メール一致チェック
    const mail = document.getElementById("customer_mail");
    const mailCheck = document.getElementById("customer_mail_check");
    if (mail && mailCheck) {
      if (mail.value !== mailCheck.value) {
        showError(mailCheck, "メールアドレスが一致していません。");
        hasError = true;
      } else {
        clearError(mailCheck);
      }
    }

    // ③ 電話番号フォーマットチェック
    const tel = document.getElementById("customer_phone_number");
    if (tel && tel.value !== "") {
      const telNormalized = tel.value.replace(/-/g, "");
      if (!/^0\d{9,10}$/.test(telNormalized)) {
        showError(
          tel,
          "正しい電話番号を入力してください。（例：090-1234-5678）",
        );
        hasError = true;
      } else {
        clearError(tel);
      }
    }

    // エラーがあれば次ステップに進まない
    if (hasError) {
      e.stopImmediatePropagation();
      return;
    }

    // ④ 値を保存してStep2に流し込む
    const savedValues = {};
    fields.forEach(function (field) {
      const inputEl = document.getElementById(field.input);
      if (inputEl) {
        savedValues[field.confirm] = inputEl.value;
      }
    });

    setTimeout(function () {
      fields.forEach(function (field) {
        const el = document.getElementById(field.confirm);
        if (el) {
          el.textContent = savedValues[field.confirm] || "";
        }
      });

      // Step2が「現在のステップ」になっているか確認
      const confirmSection = document.querySelector(".step-confirm");
      const currentFieldset = confirmSection
        ? confirmSection.closest(".fieldset-cf7mls")
        : null;
      const isStep2Active =
        currentFieldset &&
        currentFieldset.classList.contains("cf7mls_current_fs");

      if (isStep2Active) {
        confirmSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 300);
  });

  // 送信完了後の処理
  const form = document.querySelector(".wpcf7-form");
  if (form) {
    form.addEventListener(
      "wpcf7mailsent",
      function (event) {
        // フォーム全体（Step1・Step2両方）を非表示
        const formWrapper = document.querySelector(".contactForm");
        // 全Stepを内包する親要素を非表示にする
        const allFieldsets = document.querySelectorAll(".fieldset-cf7mls");
        allFieldsets.forEach(function (fieldset) {
          fieldset.style.display = "none";
        });

        // サンクス画面を表示
        const thanksScreen = document.getElementById("thanks-screen");
        if (thanksScreen) {
          thanksScreen.style.display = "block";
          thanksScreen.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      },
      false,
    );
  }

  // 「入力フォームに戻る」ボタンの処理
  const backBtn = document.getElementById("back-to-form-btn");
  if (backBtn) {
    backBtn.addEventListener("click", function () {
      location.reload(); // ページ再読み込みでフォームを初期状態に戻す
    });
  }
}
